import { TextField, InputAdornment, IconButton, Button, Box } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const AuthInput = ({
  label,
  name,
  value,
  onChange,
  icon,
  isPassword,
  showPassword,
  togglePassword,
  sendotp,
  isError,
  sent,
  disabled,
  isValid,
  otpSecondsLeft,
}) => {
  const StartIcon = icon;

  return (
    <Box sx={{ width: "100%", mb: 1.5 }}>
      <TextField
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        size="small"
        margin="dense"
        fullWidth
        sx={{ width: "100%", color: "success" }}
        type={isPassword && !showPassword ? "password" : "text"}
        error={isError}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <StartIcon />
            </InputAdornment>
          ),
          endAdornment: isPassword ? (
            <InputAdornment position="end">
              <IconButton onClick={togglePassword}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              {value && (isValid ? (
                <CheckCircleIcon color="success" />
              ) : (
                <ErrorIcon color="error" />
              ))}
            </InputAdornment>
          ),
          sx: { borderRadius: "8px" },
        }}
      />
      {name === "email" && isValid && (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
          <Button
            size="small"
            variant="contained"
            onClick={sendotp}
            disabled={!value.trim() || sent || otpSecondsLeft > 0}
          >
            {sent && otpSecondsLeft > 0
              ? `Resend in ${otpSecondsLeft}s`
              : "Send Otp"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default AuthInput;
